import React from "react"
import Link from '../utils/link'

import "./footer.scss"

const Footer = footerHeight => {
  return (
    <footer className="footer" style={{ height: footerHeight.height }}>
      <div className="footer__content">
        <div className="footer__content__manage">
          Property managed by The Best of Magnetic
        </div>
        <div className="footer__content__copy">
          © Copyright { new Date().getFullYear() }. <Link to='https://atollon.com.au'>Atollon</Link> + <Link to='https://www.codedrips.com'>CodeDrips</Link>
        </div>
      </div>
    </footer>
  )
}

export default Footer
